import { render, staticRenderFns } from "./DefinitionTaskTodo.vue?vue&type=template&id=09f67e98&"
import script from "./DefinitionTaskTodo.vue?vue&type=script&lang=js&"
export * from "./DefinitionTaskTodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports